// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Xq-n","info":"UpdateTermsInfo_info__35jj-"};